const MarketCapitalBreakdownTable = require('./MarketCapitalBreakdownTable');

module.exports = MarketCapitalBreakdownTable;
